import React, { useState, useEffect, useContext, memo } from "react";
import { Col, Form, FormGroup, Label } from "reactstrap";
import "./Detail.css";
import { Button, TextField, MessageAlert } from "../../components/Components";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import logo from '../../assets/logo/Homepro.png';
import Login from "./Components/Login";
import ResetPassword from "./Components/ResetPassword";

const Detail = (props) => {

    const {
        pageMode
    } = props;

    return (
        <Form>
            <div className="Detail-container">
                <div className="Detail-logo">
                    <img src={logo} className="LogoHomePro" alt="logo" />
                </div>
                <div className="Detail-detail">
                    { pageMode === "login" && <Login/>}
                    { pageMode === 'reset' && <ResetPassword/>}
                </div>
            </div>
        </Form>
    );
};

export const MemoizedDetail = memo(Detail);